import PropTypes from "prop-types";

export default function ReportButton({
  onClick,
  disabled = false,
  className = "",
}) {
  const baseClasses =
    "flex items-center gap-1 text-xs font-medium transition-colors";
  const enabledClasses =
    "text-gray-500 dark:text-gray-400 hover:text-red-600 dark:hover:text-red-400";
  const disabledClasses = "text-gray-400 dark:text-gray-600 cursor-not-allowed";

  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`${baseClasses} ${
        disabled ? disabledClasses : enabledClasses
      } ${className}`.trim()}
    >
      <span>Report</span>
    </button>
  );
}

ReportButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
